/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-06-26 12:17:44
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-07-13 12:51:52
 * @FilePath: \大屏项目\src\components\element\attrs\cpt-date-picker.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
    attribute:{
        defaultValueType: null,
        defaultValue: '',
        defaultValueEnd:'',
        defaultValueEN:'',
        defaultValueEndEN:'',
        daterange:false,
        dateFormat:'date',
        label: '日期：',
        labelAlign:'right',
        labelWidth:100,
        placeholder: '请选择',
        size: 'medium', 
        width:144,
        height:32,
        align:"left",
        indent:0,
        bgColor: '#00000000',
        textColor: '#fff',
        textPlaceholderColor: '#333',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontFamily: '微软雅黑',
        fontSize: 12,
        textColor: '#ffffff',
        borderSize: 1,
        borderColor: '#333333',
        borderRadus: 0,
        lineType: 'solid',
        required: false,
        panelBg:'#00000000',
        activeBgColor: '#2684ff',
        activeColor: '#2684ff',
        disableColor:'#ffffff',
        disableBg:'#00000000',
        bg:'#00000000',
        panelNum:'',
        activeNum: '',
        activeNum: '',
        disableBool:false,
        disableBool:false,
        bgBool:false,
        btnBg:"#2684ff",
        btnColor:"fff",
        panelColor:"#ffffff8c",
        timeIcon:true,
        timeIconBg:"#333",
        direction:'column',
        cptTableData: [{ "name": "值", "value": "", "namekey": "value" }],
    },
    cptDataForm: {
        dataText: '{"value":""}',
        dataSource: 1,
        pollTime: 0,
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },
    interaction: { eventText: '完成输入时' }
}